import React from 'react';
import './possibility.css';

const Layout = ({ height, heading, text, layout , image, index}) => {
  if (layout === 0)
    return (
      <div className='features_main' id='roadmap'>
        <div className="gpt3__features px-2 " id="features">
          <div className="gpt3__features-heading">
            <h1 className="gradient__text">{heading}</h1>
            <p>{text}</p>
          </div>
          <div className="gpt3__features-container">
            <div>
              <img src={image} style={{ height: height }}></img>
            </div>
          </div>
        </div>
      </div>
    )

  else return (<div className={`gpt3__possibility ${index === 6 ? "section__padding" : "section__padding_2"}`} id="possibility">
    <div className="gpt3__possibility-image">
      <img src={image} alt="image" style={{ height: height }} className='pos_img'/>
    </div>
    <div className="gpt3__possibility-content">
      <h4> </h4>
      <h1 className="gradient__text">{heading}</h1>
      <p>{text} </p>
      {/* <h4>ABOUT AUTHOR: A marketing manager with 3+ years of community management and experience for multiple startups in the cryptocurrency sector. Gabriel has been founder of numerous web3 and non profit start ups. He Has been minting, researching, and earning certifications in the cryptocurrency, NFT, blockchain, AR space for the last 10 years. He is an active member in over 5k Discord channels and helps build communities within NFT spaces (has been active on Discord since the launch of the platform). Gabriel is an avid crypto, blockchain, web3, and DAO enthusiast who has minted NFTs on 5 different platforms using Artificial Intelligence art. He has an extensive experience building and nurturing online communities organically. He has also in the past worked in the inner city building communities as well. Most notably a teacher, basketball coach and mentor in NYC. Gabriel is also the Author of “Gentritrying”, a NFT book that focuses on gentrification in minority neighborhoods all across America. </h4> */}
    </div>
  </div>)
};

export default Layout;
